import * as types from "../actions/actionsTypes";
import initialState from "./initialState";

export default function subscriptionDataReducer(
  state = initialState.subscription,
  action
) {
  switch (action.type) {
    case types.LOADED_SUBSCRIPTION_DATA_SUCCESS:
      return action.subscription;
    default:
      return state;
  }
}
